
define('ldsh!modules/editor/templates/editors/video', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-overlay-container">\n    <div class="ed-modal-header ed-opt-toolbar">\n      <div class="ed-toolgroup">\n          <b title="Guardar cambios" data-i18n="[title]editor.toolbar.saveButton" class="ed-c-btn ed-c-btn-default js-save"><span class="ed-icon ed-icon-save"></span><span data-i18n="editor.toolbar.saveButton" class="ed-c-btn-text"></span></b>\n        </div>\n      <button type="button" class="close js-close" data-dismiss="modal" aria-hidden="true">\n        <i class="ri-close-line"></i>\n      </button>\n    </div>\n    <div class="ed-modal-content js-content">\n      <textarea id="videoEditor" class="hidden" style="height: 100%; width: 100%">' +
((__t = (content)) == null ? '' : __t) +
'</textarea>\n    </div>\n</div>\n';

}
return __p
};});

